import React from 'react'

import Text from 'components/_new/typography/Text/Text'

import s from './FooterCopy.scss'
import messages from './messages'


const FooterCopy = () => (
  <footer className={s.footer}>
    <Text size="20-24" message={messages.copy} color="gray-50" />
  </footer>
)


export default FooterCopy
